<template>
    <va-edit-layout>
        <ServiceFeeEvent-form
            :id="id"
            :title="title"
            :item="item"
        ></ServiceFeeEvent-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
